<template>
    <h2 class="text-left">{{title}}</h2>
</template>

<script>
export default {
  name: 'SubHeader',
  props: {
    title: String
  }
}
</script>

<style scoped>

h2 {
  border-bottom: 1px solid #e5e5e5;
  font-size: 1.5rem;
  margin-bottom: 18px;
}

</style>
